import { createContext } from 'react';
import { TodoListContext } from '../Modules/TodoList/Context';

export type AssigneeContext = Pick<TodoListContext, 'assignee' | 'setAssignee'>;

export default createContext<AssigneeContext>({} as unknown as AssigneeContext);
